import React, { useState, useCallback, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useLocation, useHistory } from 'react-router-dom';
import Swal from "sweetalert2";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import MobileView from "../../../components/design/layout/mobile";
import { PartnerHead } from "../../../components/design/layout/partner-head";
import { Headline } from "../../../components/design/foundation/headline";
import { Container } from "../../../components/design/layout/container";
import ProductBox from "../../../components/design/layout/product-box";
import Button from "../../../components/design/form/button"
import {NothingMessage} from "../../../components/ui/nothing-message";

import { WrapperContainer, ContentDescription, ProductsGrid, WrappLoadMore } from "./styles";

import OfferService from '../../../services/Offer';
import PartnerService from '../../../services/Partner';

import loadImage from "../../../utils/LoadImage";
import ProductLoader from "../../../components/design/layout/loader/product";

import handleURLParams from "../../../utils/handleURLParams";

import ImagePlaceholder from "../../../assets/images/placeholder.png";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        boxShadow: 'none !important',
        borderBottom: '1px solid #F1F1F1',
        margin: '0 !important',
        '&::before': {
            backgroundColor: 'transparent'
        }
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightBold,
        fontFamily: `'Nunito', sans-serif`,
        color: `#3A3E4A`
    },
    text: {
        fontSize: theme.typography.pxToRem(13),
        fontWeight: theme.typography.fontWeightMedium,
        fontFamily: `'Nunito', sans-serif`,
        color: `#515157`
    },
    icon: {
        padding: '8px'
    }
}));

function Partner({ website }) {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const search = new URLSearchParams(location.search);
    const partnerId = search.get('partnerId');

    const [limit, setLimit] = useState(8);
    const [offers, setOffers] = useState([]);
    const [partner, setPartner] = useState({});
    const [contentDescription] = useState(false);

    // * Loading States
    const [isLoading, setIsLoading] = useState(true);

    const searchOfferByPartner = ({ limit }) => {
        const offerService = new OfferService();

        offerService.listBySearch({
            limit: limit,
            partner: partnerId
        }).then((response) => {
            setOffers(response.data.payload);

            if (response.data.payload) {
                setIsLoading(status => status = false);
            }

        }).catch(err => {
            Swal.fire({
                icon: "error",
                html: err.message,
                title: "",
            });
        });;
    };

    const loadMore = () => {
        const newLimit = limit + 8;
        setLimit(newLimit);

        searchOfferByPartner({ limit: newLimit })
    }

    const handleInitialInfo = useCallback(() => {
        const partnerService = new PartnerService();

        partnerService.findByID({ partnerID: partnerId }).then((response) => {
            setPartner(response.data.payload);
        }).catch(err => {
            Swal.fire({
                icon: "error",
                html: err.message,
                title: "",
            });
        });


    }, [partnerId]);

    useEffect(() => {
        searchOfferByPartner({ limit: limit });
        handleInitialInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handleInitialInfo, limit]);

    useEffect(() => {
        return function cleanup() {
            handleURLParams({
                listOfKeyValues: [
                    { key: 'partnerId', value: undefined }
                ],
                location: history.location,
                history: history
            })
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <MobileView pageTitle="Voltar" borderBottom={true} activeBackHistory contentMarginTop={46}>
                {partner && (
                    <PartnerHead
                        title={partner.nome}
                        cover={isLoading ? ImagePlaceholder : loadImage({ imageCode: partner?.imagem_banner })}
                        partnerLogo={isLoading ? ImagePlaceholder : loadImage({ imageCode: partner?.imagem_avatar })}
                        withButton={true}
                    >
                        {/*<ShowDesciptionButton icon={<Icon icon={!contentDescription ? ["far", "chevron-down"] : ["far", "chevron-up"]} />} onClick={handleContentDescription} />*/}
                    </PartnerHead>
                )}

                <WrapperContainer>
                    <Container withContainer={true} >

                        {contentDescription && (
                            <ContentDescription>
                                <Accordion className={`${classes.root} AccordionPartnerDescription`}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>Sobre a loja</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography className={classes.text}>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                                            sit amet blandit leo lobortis eget.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion className={`${classes.root} AccordionPartnerDescription`}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                    >
                                        <Typography className={classes.heading}>Política de entrega</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography className={classes.text}>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                                            sit amet blandit leo lobortis eget.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion className={`${classes.root} AccordionPartnerDescription`}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel3a-content"
                                        id="panel3a-header"
                                    >
                                        <Typography className={classes.heading}>Política de troca, devolução e cancelamento</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography className={classes.text}>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                                            sit amet blandit leo lobortis eget.
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </ContentDescription>
                        )}

                        <Headline
                            type="medium"
                            title="Principais ofertas"
                            withLink={false}
                            textAlign="left"
                        />

                        <ProductsGrid>
                            {isLoading && (<Grid container spacing={0}>
                                {[0, 1, 2, 3].map((item, i) =>
                                    <Grid key={`${item}-${i}`} item xs={6}>
                                        <ProductLoader />
                                    </Grid>
                                )}
                            </Grid>)}

                            {offers.length > 0 ? offers.map((item, i) => (
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <ProductBox
                                            key={`${item._id}-${i}`}
                                            gridMargin={5}
                                            productId={item._id}
                                            discountValue={item.descont ? item.descont : null}
                                            productTitle={item.titulo}
                                            image={loadImage({ imageCode: item.imagens[0] })}
                                            productPrice={item.oferta}
                                            productType={item.tipo_oferta}
                                            priceColor={props => props.theme[website]?.components.productBox.priceColor}
                                        />
                                    </Grid>
                                </Grid>
                            )) :
                                <NothingMessage>
                                    Não há ofertas por enquanto.
                                </NothingMessage>
                            }
                        </ProductsGrid>

                        <WrappLoadMore>
                            {limit <= offers.length ?
                                (
                                    <Button
                                        styleType="bordered"
                                        buttonSize="small"
                                        buttonColor={props => props.theme[this.props.website]?.button.background}
                                        textColor={props => props.theme[this.props.website]?.button.color}
                                        borderColor={props => props.theme[this.props.website]?.button.background}
                                        buttonText="Mostrar mais produtos"
                                        maxWidth={200}
                                        onClick={() => loadMore()}
                                    />
                                ) : (<></>)
                            }
                        </WrappLoadMore>
                    </Container>
                </WrapperContainer>
            </MobileView>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        website: state.websiteReducer.website
    };
};

export default withRouter(connect(mapStateToProps)(Partner));